import "./Navbar.css";
import { useState, useEffect } from "react";
import { Link } from "react-scroll";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Function to check scroll position
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to close menu when clicking a menu item
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={`header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="container-fluid">
        <div id="logo" className="logo">
          <Link to="Hero" smooth={true} duration={500}>
            <img src="/Logo.png" alt="PodSutra Logo" className="nav-logo1" />
          </Link>
        </div>

        <button 
          className="menu-toggle" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>

        <nav id="nav-menu-container" className={isMenuOpen ? "open" : ""}>
          <ul className="nav-menu">
            <li>
              <Link to="Process" smooth={true} duration={500} offset={-80} onClick={closeMenu}>
                Process
              </Link>
            </li>
            <li>
              <Link to="Studio" smooth={true} duration={500} offset={-80} onClick={closeMenu}>
                Facilities
              </Link>
            </li>
            <li>
              <Link to="StudioImg" smooth={true} duration={500} onClick={closeMenu}>
                Studio
              </Link>
            </li>
            <li>
              <Link to="Contact" smooth={true} duration={500} offset={-210} onClick={closeMenu}>
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
